import React from "react";

const TeamsSection = () => (
  <section className="faqs" id="teams" aria-labelledby="teams-title">
    <div className="container">
      <div className="section-head">
        <span className="section-num">07</span>
        <h2 className="section-title" id="teams-title">
          Bringing 42courses to your <em>team</em>.
        </h2>
      </div>

      <div className="b2b-handoff">
        <div className="b2b-handoff-text">
          <h3>
            Got a team? <em>We've got a page for that.</em>
          </h3>
          <p>
            Team plans, custom learning paths, SSO, dedicated success manager,
            the lot. Including answers to "what's the minimum size", "how does
            pricing work", "how fast can we onboard", and "do you do bespoke
            workshops".
          </p>
        </div>
        <a href="/team_plans" className="btn-handoff">
          See team plans →
        </a>
      </div>
    </div>
  </section>
);

export default TeamsSection;
